// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {

  // PROD Environment settings.
  production: true,

// Local
// baseURL: 'http://localhost:4200',
// serviceURL: 'https://localhost:44354',

// DEV
  // baseURL: 'https://ams-dev.azurewebsites.net',
  // serviceURL: 'https://ams-dev-api.azurewebsites.net',

// QA
//  baseURL: 'https://amsqa.azurewebsites.net',
//  serviceURL: 'https://amsqa-api.azurewebsites.net',

// PROD
 baseURL: 'https://amslive.azurewebsites.net',
 serviceURL: 'https://amsliveapi.azurewebsites.net',

  // Az AD.
  scopeUri: ['api://b9b11b4c-9547-49f1-9f2e-fa63b8ec5120/access_as_user'],
  loginScopes: ['user.read'],
  authorityUrl: 'https://login.microsoftonline.com/',
  tenantId: '2ef48f78-425e-4c0e-8e55-a179539695cb',
  clientId: 'b9b11b4c-9547-49f1-9f2e-fa63b8ec5120',
  // redirectUrl: 'http://localhost:4200',
  // redirectUrl: 'https://ams-dev.azurewebsites.net',
  // redirectUrl: 'https://amsqa.azurewebsites.net',
    redirectUrl: 'https://amslive.azurewebsites.net',

  // Sharepoint configs.
  spClientId: '8510519f-bb69-4065-b515-70ba3571143f',
  spClientSecret: 'zvdujTfljUp4kltMGbeASCQW1+z//Kv7ItKtVCjI4I0=',
  spGrantTypeValue: 'grant_type',
  spTenantId: '2ef48f78-425e-4c0e-8e55-a179539695cb',
  spResource: '00000003-0000-0ff1-ce00-000000000000/pedaidsorg.sharepoint.com@2ef48f78-425e-4c0e-8e55-a179539695cb',
  spBaseUrl: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase',
  spGetTokenUrl: 'https://accounts.accesscontrol.windows.net/2ef48f78-425e-4c0e-8e55-a179539695cb/tokens/OAuth/2',
  // spGetFiles: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase/_api/web/Lists/getbytitle(\'AMS\')/Items',// DEV
  // spGetFiles: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase/_api/web/Lists/getbytitle(\'AMSMigrationPROD\')/Items',
  // spGetFiles: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase/_api/web/Lists/getbytitle(\'AMSTest\')/Items',//QA
  // spGetFiles: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase/_api/web/Lists/getbytitle(\'AMSUAT\')/Items',
   spGetFiles: 'https://pedaidsorg.sharepoint.com/sites/AwardMaintenanceSystemDatabase/_api/web/Lists/getbytitle(\'AMSLive\')/Items',// PROD

  // Auto save
  autoSave: 300000, // 60000 for 1 min
  isAutoSaveEnableFlag: 1, // 0 for disable, 1 for enable

  // API routings.
  getCountry: '/api/AMS/Lookup/Country/IdValues',
  getDonorAgency: '/api/AMS/Lookup/DonorAgency/IdValues',
  getAgreementStatus: '/api/AMS/Lookup/AgreementStatus/IdValues',
  getActivity: '/api/AMS/Lookup/Activity/IdValues',
  getTechnicalArea: '/api/AMS/Lookup/TechnicalArea/IdValues',
  getContact: '/api/AMS/Lookup/Contact/IdValues',
  getRegion: '/api/AMS/Lookup/Region/IdValues/',
  postAwardInformation: '/api/AMS/Agreement/SaveAgreement',
  postAgreementDetails: '/api/AMS/Agreement/SaveAgreementDetail',
  getAgreements: '/api/AMS/Agreement/Agreements',
  getDonorContacts: '/api/AMS/Agreement/DonorContactsByDonor/',
  postSaveAgreementCountry: '/api/AMS/Agreement/SaveAgreementCountry',
  postSaveAgreementRegion: '/api/AMS/Agreement/SaveAgreementRegion',
  postSaveDonorContact: '/api/AMS/Agreement/SaveDonorContact',
  postAgreementTechnicalArea: '/api/AMS/Agreement/SaveAgreementTechnicalArea',
  postCountryImplementation: '/api/AMS/Agreement/SaveCountryOfImplementation',
  deleteCountryImplementation: '/api/AMS/Agreement/DeleteAgreementActivityManager',
  getAgreementInformationDetails: '/api/AMS/Agreement/Information/',
  postAgreementActivity: '/api/AMS/Agreement/SaveAgreementActivity',
  deleteAgreementCountry: '/api/AMS/Agreement/DeleteAgreementCountry',
  deleteAgreementRegion: '/api/AMS/Agreement/DeleteAgreementRegion',
  deleteDonorContact: '/api/AMS/Agreement/DeleteDonorContact',
  postSaveAgreementDonorContact: '/api/AMS/Agreement/SaveAgreementDonorContact',
  deleteAgreementDonorContact: '/api/AMS/Agreement/DeleteAgreementDonorContacts',
  deleteAgreementActivity: '/api/AMS/Agreement/DeleteAgreementActivity',
  deleteTechnicalArea: '/api/AMS/Agreement/DeleteAgreementTechnicalArea',
  getDonorsList: '/api/AMS/Lookup/DonorAgency/IdValues',
  getDonorInformation: '/api/AMS/Agreement/DonorInformation/',
  postDonorInformation: '/api/AMS/Agreement/SaveDonor',
  postDonorContact: '/api/AMS/Agreement/SaveDonorContacts',
  getDeliverablesType: '/api/AMS/Lookup/DeliverableType/IdValues',
  getNotificationFrequency: '/api/AMS/Lookup/NotificationFrequency/IdValues',
  getDocumentType: '/api/AMS/Lookup/DocumentType/IdValues',
  uploadDocument: '/api/AMS/Agreement/Attachment/Upload',
  saveDocument: '/api/AMS/Agreement/SaveAgreementDocuments',
  deleteDocument: '/api/AMS/Agreement/DeleteAgreementDocument',
  deleteDocumentFile: '/api/AMS/Agreement/DeleteFile',
  downloadDocument: '/api/AMS/Agreement/Download',
  getDocumentDetails: '/api/AMS/Agreement/GetDocument',
  getAuditDocuments: '/api/AMS/Audit/Documents/',
  getAwardContacts: '/api/AMS/Agreement/AwardContacts/',
  deleteDonorInfoEntryContacts: '/api/AMS/Agreement/DeleteContacts',
  getAllCountry: '/api/AMS/Agreement/AgreementCountryByAgreement/',
  getRegionCountry: '/api/AMS/Agreement/AgreementRegionByAgreement/',
  getDeliverableInformation: '/api/AMS/Deliverable/GetByAgreement/',
  postDeliverableInformation: '/api/AMS/Deliverable/SaveDeliverable',
  deleteDeliverableInformation: '/api/AMS/Deliverable/DeleteAgreementDeliverable',
  getDeliverablePeriod: '/api/AMS/Lookup/DeliverablePeriod/IdValues',
  getDeliverablePeriodValue: '/api/AMS/Lookup/DeliverablePeriodValue/',
  getFunder: '/api/AMS/Lookup/Funder/IdValues',
  saveNotes: '/api/AMS/Note/Save',
  getNotes: '/api/AMS/Note/GetByAgreement/',
  deleteNotes: '/api/AMS/Note/Delete',
  getPriorApprovalsType: '/api/AMS/Lookup/PriorApprovalType/IdValues',
  getPriorApprovalsInformation: '/api/AMS/PriorApproval/GetByAgreement/',
  savePriorApprovalsInformation: '/api/AMS/PriorApproval/Save',
  deletePriorApprovals: '/api/AMS/PriorApproval/Delete',
  getAwardAudit: '/api/AMS/Audit/Agreement/',
  getAllUsers: '/api/AMS/Lookup/Users/IdValues',
  postDataMigration: '/api/AMS/Lookup/ImportAgreement',
  documentDataMigration: '/api/AMS/Lookup/ImportDocument',
  getDeliverableDetails: '/api/AMS/Deliverable/GetByDeliverable/',
  postDeliverableDetails: '/api/AMS/Deliverable/SaveDeliverableDetails',
  deleteDeliverableDetails: '/api/AMS/Deliverable/DeleteDeliverableDetails',
  getAdminCheck: '/api/AMS/Agreement/AdminCheck',
  getIsAwardYearUsed: '/api/AMS/Agreement/IsAwardYearUsed/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
